import {
  CommissionDetails,
  FlatCommission,
  FlatCommissionType,
  TieredCommission,
  ValueType,
  VendorChoice,
} from '@urbanx/agx.campaigns.client';

const PERCENTAGE_COMMISSION_UNDER_MINIMUM = 1.5;
const FLAT_FEE_COMMISSION_UNDER_MINIMUM = 1000;

const isFlatCommissionBelowMinimum = (flatCommission?: FlatCommission) => {
  if (flatCommission?.amount === undefined) return false;

  return (
    (flatCommission.flatCommissionType === FlatCommissionType.Percentage &&
      flatCommission.amount <= PERCENTAGE_COMMISSION_UNDER_MINIMUM) ||
    (flatCommission.flatCommissionType === FlatCommissionType.FlatFee &&
      flatCommission.amount <= FLAT_FEE_COMMISSION_UNDER_MINIMUM)
  );
};

const isTieredCommissionBelowMinimum = (tieredCommission?: TieredCommission) =>
  tieredCommission?.rows?.some(
    (row) =>
      row.percentageWithinBound !== undefined &&
      row.percentageWithinBound <= PERCENTAGE_COMMISSION_UNDER_MINIMUM
  ) === true;

const isAtOrBelowMinimum = (amount: number | undefined, minimum: number) =>
  amount !== undefined && amount <= minimum;

const isVendorChoiceBelowMinimum = (vendorChoice?: VendorChoice) => {
  if (!vendorChoice) return false;

  switch (vendorChoice.valueType) {
    case ValueType.Percentage:
      return (
        isAtOrBelowMinimum(vendorChoice.minCommission, PERCENTAGE_COMMISSION_UNDER_MINIMUM) ||
        isAtOrBelowMinimum(vendorChoice.maxCommission, PERCENTAGE_COMMISSION_UNDER_MINIMUM)
      );
    case ValueType.Dollar:
      return (
        isAtOrBelowMinimum(vendorChoice.minCommission, FLAT_FEE_COMMISSION_UNDER_MINIMUM) ||
        isAtOrBelowMinimum(vendorChoice.maxCommission, FLAT_FEE_COMMISSION_UNDER_MINIMUM)
      );
    default:
      return false;
  }
};

export const hasBelowMinimumCommission = (commissionDetails?: CommissionDetails) =>
  isFlatCommissionBelowMinimum(commissionDetails?.flatCommission) ||
  isTieredCommissionBelowMinimum(commissionDetails?.tieredCommission) ||
  isVendorChoiceBelowMinimum(commissionDetails?.vendorChoice);
